/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import * as HERBUI from "react-bootstrap";
import "../loginandlandingpage.css";
import * as Yup from 'yup';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { LOGIN_AUTHENTICATION_URL, LOGIN_DOMAIN, AUTHENTICATION_URL, USER_VERIFICATION_OTP } from "../Api/APIURLS";
import { useDispatch } from "react-redux";
import { CommonAjaxPostLoginRequest } from '../Api/CommonAjaxUtils'
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { origins } from "../components/Functions";
import Swal from "sweetalert2";
import MobileNumbersPopUp from "./MobileNumbersPopUp";
import PensionsMobileNumbersPopUp from "./PensionsMobileNumbersPopUp";
var createHost = require('cross-domain-storage/host');
var createGuest = require('cross-domain-storage/guest');
const LoginPageAuthentication = () => {
    var storageHost = null;
    var mainAppguest = null;
    const [errorMsg, setErrorMsg] = useState('')
    const [otpStatus, setOtpStatus] = useState('')
    const [showFields, setShowFields] = useState(false)
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const [showpopup, setShowPopup] = useState(false);
    const [showPensionspopup, setShowPensionsPopup] = useState(false);
    const handleOpen = () => setShowPopup(true);
    const handleClose = () => setShowPopup(false);
     const [showFieldsOtp, setShowFieldsOtp] = useState(false)

    const intialValues = {
        username: '', password: '', otp: "", name: "", mobileNo: "",
        email: "", uid: "", trn: "", OTpValidation: '', aadhaarType: '', showPassword: false
    }
    const [buttonType, setButtonType] = useState("")
    const [disableUsername, setDisableUserName] = useState(false)
    const [passwordType, setPasswordType] = useState("password");
    const [msg, setMsg] = useState("")
    const [passwordValidation, setPasswordValidation] = useState(false)
    const validationSchema = Yup.object({
        username: Yup.string().required('Required'),
    })
    const otpPasswordValidation = Yup.object({
        otp: Yup.string().required("Required"),
        password: Yup.string().required("Required")
    })
    const UserPasswordValidation = Yup.object({
        username: Yup.string().required('Required'),
        password: Yup.string().required("Required")
    })

    useEffect(() => {
        storageHost = createHost(
            origins.map(origin => ({ origin, allowedMethods: ['get', 'set', 'remove'] }))
        );
    }, [])
    const formik = useFormik({
        initialValues: intialValues,
        validationSchema: buttonType === "SignIn" ? (passwordValidation === false ? UserPasswordValidation : otpPasswordValidation) : validationSchema,
        onSubmit: (values) => {
            if (buttonType === "go") {
                let params = { "userId": values.username }
                // CommonAjaxGetRequestWithOutParamsWithOutAuthorization(USER_VERIFICATION + values.username).then((res) => {
                CommonAjaxPostLoginRequest(USER_VERIFICATION_OTP, params).then((res) => {
                    if (res.SCODE === "01") {
                        setOtpStatus('sent')
                        setShowFields(true)
                        setShowFieldsOtp(true)
                        setShowErrorMsg(false)
                        setDisableUserName(true)
                        setMsg(res.SDESC)
                        formik.setFieldValue("uid", res.uid)
                        formik.setFieldValue("trn", res.trn)
                        formik.setFieldValue("OTpValidation", res.optValidation)
                    }
                    else if (res.SCODE === "02") {
                        setOtpStatus('')
                        setShowFields(false)
                        setShowFieldsOtp(false)
                        setShowErrorMsg(true)
                        setErrorMsg(res.SDESC)
                        localStorage.setItem("loginFailErrorMsg", res.SDESC)
                        setDisableUserName(false)
                    }
                })

            }
            else if (buttonType === "SignIn") {
                localStorage.removeItem("token");
                localStorage.removeItem("serviceList");
                localStorage.clear();
                localStorage.setItem('userId', values.username)
                localStorage.setItem('userName', JSON.stringify(values.username))
                let params = {}
                if (String(values.OTpValidation) === "0") {
                    values.username = values.username.trim()
                    values.password = values.password.trim()
                    params = { username: values.username, password: values.password }
                    CommonAjaxPostLoginRequest(AUTHENTICATION_URL, values, dispatch, history).then((response) => {
                        if (response !== "" && response !== null && response !== undefined) {
                            localStorage.setItem("token", JSON.stringify(response.access_token));
                            localStorage.setItem("refresh_token", JSON.stringify(response.refresh_token));
                            localStorage.setItem('userData', JSON.stringify(response))
                            localStorage.setItem('userName', JSON.stringify(values.username))
                            localStorage.setItem('reloaded', 'false')
                            if (response?.message) {
                                localStorage.setItem("expirationErrorMsg", JSON.stringify(response?.message))
                            }
                            mainAppguest = createGuest(LOGIN_DOMAIN);
                            let displayName = ""
                            const base64Url = response?.access_token.split('.')[1];
                            if (base64Url !== undefined) {
                                const base64 = base64Url.replace('-', '+').replace('_', '/');
                                displayName = JSON.parse(window.atob(base64)).name
                                localStorage.setItem('displayName', JSON.stringify(displayName))
                            }
                            mainAppguest.set('token', JSON.stringify(response.access_token), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('displayName', JSON.stringify(displayName), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('userData', JSON.stringify(response), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('refresh_token', JSON.stringify(response.refresh_token), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            mainAppguest.set('userId', JSON.stringify(values.username), function (error, data) {
                                // foo is now set to 'bar'
                            });
                            history.push("/dashboard");
                        }
                        else {
                            dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                            setShowErrorMsg(true);
                            // setErrorMsg("Invalid Username or Password")
                            formik.setFieldValue('username', '');
                            formik.setFieldValue('password', '');
                            formik.setFieldValue('otp', '');
                            setDisableUserName(false)
                            setShowFields(false)
                            setShowFieldsOtp(false)
                            setOtpStatus('go')
                        }
                    });
                }
                else if (String(values.OTpValidation) === "1") {
                    params = { "uid": values.uid, "otp": values.otp, "trn": values.trn, "userId": values.username.trim(), "password": values.password.trim() }
                    CommonAjaxPostLoginRequest(LOGIN_AUTHENTICATION_URL, params, dispatch, history).then((response) => {
                        if (response.SCODE === "01") {
                            // if (response !== "" && response !== null && response !== undefined) {
                            let responseData = response.token?.body
                            localStorage.setItem("token", JSON.stringify(responseData?.access_token));
                            localStorage.setItem("refresh_token", JSON.stringify(responseData?.refresh_token));
                            localStorage.setItem('userData', JSON.stringify(responseData))
                            localStorage.setItem('userName', JSON.stringify(values.username))
                            if (responseData?.message) {
                                localStorage.setItem("expirationErrorMsg", JSON.stringify(responseData?.message))
                            }
                            if (responseData?.passwordExpiry === true) {
                                localStorage.setItem("passwordExpiry", JSON.stringify(responseData?.passwordExpiry))
                                Swal.fire({ text: responseData?.message, icon: 'error', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false }).then(function (isConfirm) {
                                    if (isConfirm.value) {
                                        history.push({ pathname: '/forgotPassword', state: 'passwordExpired' })
                                    }
                                })
                            }
                            else {
                                mainAppguest = createGuest(LOGIN_DOMAIN);
                                let displayName = ""
                                const base64Url = responseData.access_token.split('.')[1];
                                if (base64Url !== undefined) {
                                    const base64 = base64Url.replace('-', '+').replace('_', '/');
                                    displayName = JSON.parse(window.atob(base64)).name
                                    localStorage.setItem('displayName', JSON.stringify(displayName))

                                }
                                mainAppguest.set('token', JSON.stringify(responseData?.access_token), function (error, data) {
                                    // foo is now set to 'bar'
                                });
                                mainAppguest.set('displayName', JSON.stringify(displayName), function (error, data) {
                                    // foo is now set to 'bar'
                                });
                                mainAppguest.set('userData', JSON.stringify(responseData), function (error, data) {
                                    // foo is now set to 'bar'
                                });
                                mainAppguest.set('refresh_token', JSON.stringify(responseData?.refresh_token), function (error, data) {
                                    // foo is now set to 'bar'  
                                });
                                mainAppguest.set('userId', JSON.stringify(values.username), function (error, data) {
                                    // foo is now set to 'bar'  
                                });

                                history.push("/dashboard");
                            }
                        }
                        else if (response.SCODE === "02") {
                            setErrorMsg(response.SDESC)
                            localStorage.setItem("loginFailErrorMsg", response.SDESC)
                            if (response?.message) {
                                localStorage.setItem("expirationErrorMsg", JSON.stringify(response?.message))
                            }
                            if (response?.passwordExpiry === true) {
                                localStorage.setItem("passwordExpiry", JSON.stringify(response?.passwordExpiry))
                                Swal.fire({ text: response?.message, icon: 'error', allowEnterKey: false, allowEscapeKey: false, allowOutsideClick: false }).then(function (isConfirm) {
                                    if (isConfirm.value) {
                                        history.push({ pathname: '/forgotPassword', state: 'passwordExpired' })
                                    }
                                })
                            }
                            dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                            setShowErrorMsg(true);
                            formik.setFieldValue('username', '');
                            formik.setFieldValue('password', '');
                            formik.setFieldValue('otp', '');
                            setDisableUserName(false)
                            setShowFields(false)
                            setShowFieldsOtp(false)
                            setOtpStatus('go')
                        }
                    }).catch(() => setTimeout(() => { }, 1500));;
                }

            }
        }
    });
    useEffect(() => {
        if (String(formik.values.OTpValidation) === "0") {
            setPasswordValidation(false)
        }
        else if (String(formik.values.OTpValidation) === "1") {
            setPasswordValidation(true)
        }
    }, [formik.values.OTpValidation])
    function knowYourChallan() {
        history.push('/knowYourCfmsId')
    }
    function forgotPassword() {
        history.push("/forgotPassword");
    }
    function gos() {
        history.push("/gos");
    }
    function newAlerts() {
        history.push("/budgetRelatedPdfDetails");
    }
    function usermanuals() {
        history.push("/usermanuals")
    }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }
    const apfrsMobileApp = () => {
        history.push("/mobileApp")
    }
    const nidhiUserManualsApp = () => {
        history.push("/nidhiUserManuals")
    }

    function openPopup() {
       
        setShowPopup(true);
    }
    function openPensionsPopup() {
       
        setShowPensionsPopup(true);
    }
    const handleClosePensions = () => setShowPensionsPopup(false);
    return (
        <>
        <div className="loginnewwholediv">
            <FormikProvider value={formik}>
                <HERBUI.Navbar collapseOnSelect expand="lg" className="HERB-Top-Nav" variant="dark">
                    <HERBUI.Container fluid>
                        <HERBUI.Navbar.Brand href="/login">
                            <img
                                src="img/herb.svg"
                                width="250"
                                height="45"
                                className="d-inline-block align-top"
                                alt="NIDHI"
                            />
                        </HERBUI.Navbar.Brand>
                        <HERBUI.Navbar.Toggle className="bg-secondary" aria-controls="responsive-navbar-nav" style={{ marginRight: '30px' }} />
                        <HERBUI.Navbar.Collapse id="responsive-navbar-nav">
                            <HERBUI.Nav className="me-auto"></HERBUI.Nav>
                            <HERBUI.Nav>
                                {/* <HERBUI.Nav.Link href={'https://epts.ap.gov.in/opts/login.html'} target="_blank" rel="noreferrer" className="nav_link1">
                                    <b>HR Mapping<img src="../img/gif_new.gif" alt="new" /></b>
                                </HERBUI.Nav.Link> */}

                                <HERBUI.Nav.Link onClick={() => knowYourChallan()} className="nav_link1">
                                    <b  >Know Your CFMS ID</b>
                                </HERBUI.Nav.Link>&nbsp;&nbsp;&nbsp;&nbsp;
                                <HERBUI.Nav.Link onClick={() => gos()} className="nav_link1">
                                    <b  >GOs, Circulars, Memos</b>
                                </HERBUI.Nav.Link>
                                <HERBUI.Nav.Link onClick={() => newAlerts()} className="nav_link1">
                                    {/* <b>Budget 2023-24</b> */}
                                    <b>Budget 2026-27<img src="../img/gif_new.gif" alt="new" /></b>
                                </HERBUI.Nav.Link>
                                {/* <HERBUI.Nav.Link href={'https://appstore.nidhi.apcfss.in/iOSHerb.html'} target="_blank" rel="noreferrer" className="nav_link1">
                                    <b>Download Employee Mobile APP (NIDHI)</b>
                                </HERBUI.Nav.Link> */}
                                {/* <HERBUI.Nav.Link href={'https://appstore.nidhi.apcfss.in/iOSHerb.html'} target="_blank" rel="noreferrer" className="nav_link1">
                                    <b>Download Employee Mobile APP</b>
                                </HERBUI.Nav.Link>

                                <HERBUI.Nav.Link className="nav_link1" onClick={() => apfrsMobileApp()}>
                                    <b>APFRS Mobile APP</b>
                                </HERBUI.Nav.Link> */}
                                <HERBUI.NavDropdown
                                    title={<b>Mobile Apps</b>}
                                    id="mobile-apps-dropdown"
                                    className="nav_link1"
                                >
                                    <HERBUI.NavDropdown.Item
                                        href="https://appstore.nidhi.apcfss.in/iOSHerb.html"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Download Employee Mobile APP
                                    </HERBUI.NavDropdown.Item>

                                    <HERBUI.NavDropdown.Divider />

                                    <HERBUI.NavDropdown.Item
                                        onClick={() => apfrsMobileApp()}
                                    >
                                        APFRS Mobile APP
                                    </HERBUI.NavDropdown.Item>
                                </HERBUI.NavDropdown>

                                <HERBUI.Nav.Link
                                    className="nav_link1"
                                    onClick={() => nidhiUserManualsApp()}
                                // onClick={() => navigate("/usermanuals")}
                                >
                                    <b>NIDHI User Manuals</b>
                                </HERBUI.Nav.Link>

                            </HERBUI.Nav>
                        </HERBUI.Navbar.Collapse>
                    </HERBUI.Container>
                </HERBUI.Navbar>
                <img src="img/corner.svg" className="corner" alt="dots" />
                <div className={`loginnew-form ${showFieldsOtp ? "otp-visible" : "otp-hidden"}`} autoComplete="off">
                   <div className="login-form-main">
                            <form className="" onSubmit={formik.handleSubmit}>
                                <input
                                    type="text"
                                    name="chrome_dummy_username"
                                    autoComplete="username"
                                    style={{ display: "none" }}
                                />
                                <input
                                    type="password"
                                    name="chrome_dummy_password"
                                    autoComplete="new-password"
                                    style={{ display: "none" }}
                                />
                                <div className="inner-herbpage-service-title-sub-np">
                                    <h1 style={{ fontSize: '22px' }}> Login </h1>
                                </div>
                                <HERBUI.InputGroup className="mb-3 form-floating">
                                    <Field name="username" placeholder="User ID" id="ids" type="text" aria-label="User ID" aria-describedby="basic-addon1"
                                        maxLength={15}
                                        className="form-control rounded" readOnly={disableUsername}
                                        autoComplete="new-username" />
                                    <label for="ids">User ID</label>

                                    {showFields === false &&
                                        <button type="submit" className="btn btn-success rounded ms-2" onClick={() => setButtonType("go")}>Go</button>}

                                    <ErrorMessage name="username" className="text-error" component="div" />
                                </HERBUI.InputGroup>


                                {showFields &&
                                    <>
                                        {
                                            String(formik.values.OTpValidation) === "1" &&
                                            <div className='alert alert-info'>
                                                <span className='mb-1'>{msg}</span>
                                                &nbsp;&nbsp;
                                            </div>
                                        }
                                        {(otpStatus === 'sent' && String(formik.values.OTpValidation) === "1") &&
                                            <HERBUI.InputGroup className="mb-3 form-floating">
                                                <Field placeholder="Enter OTP" id="otp" name="otp" type="text" aria-label="OTP" maxLength={6}
                                                    aria-describedby="basic-addon1" className="form-control rounded" autoComplete="off"
                                                    onChange={(e) => {
                                                        formik.setFieldValue('otp', e.target.value)
                                                    }}
                                                />
                                                <label for="otp">OTP</label>
                                                <ErrorMessage className="text-error" name="otp" component={"div"} />
                                            </HERBUI.InputGroup>
                                        }
                                        {otpStatus === 'sent' &&
                                            <HERBUI.InputGroup className="mb-3 form-floating" >

                                                <Field placeholder="Enter Password" name="password" type={passwordType} aria-label="Password" aria-describedby="basic-addon1"
                                                    className="form-control rounded" id="passwords"

                                                    onChange={(e) => {
                                                        formik.setFieldValue("password", (e.target.value + "").trim())

                                                    }} autoComplete="new-password"
                                                />
                                                <label for="passwords">Password</label>
                                                <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                                    {passwordType === "password" ? <FaEyeSlash onClick={togglePassword} /> : <FaEye onClick={togglePassword} />}
                                                </HERBUI.InputGroup.Text>
                                                <ErrorMessage className="text-error" name="password" component={"div"} />
                                            </HERBUI.InputGroup>
                                        }
                                    </>
                                }

                                <div className="d-grid gap-2">
                                    {otpStatus === 'sent' &&
                                        <HERBUI.Button variant="primary" type="submit" className="btn_primary signin-bg rounded" onClick={() => setButtonType("SignIn")}>
                                            Sign in
                                        </HERBUI.Button>
                                    }
                                    <a className="text-center forgot mb-4" style={{ zIndex: "9994" }} onClick={() => forgotPassword()} onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            forgotPassword()
                                        }
                                    }}>Forgot Password ?</a>
                                      
                                </div>
                                {/* <div style={{ whiteSpace: "nowrap" }}>
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>Note:</span>{' '}
                                    PSE (Public Sector Entities) HR & Payroll Module Technical Supporting Team Contact Numbers.
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowPopup(true);
                                        }}
                                        style={{ marginLeft: "5px", cursor: "pointer", textDecoration: "underline" }}
                                    >
                                        Click Here
                                    </a>
                                </div> */}
                                {/* <div style={{ textAlign: 'center', padding: '10px 0' }}>
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>Note:</span>{" "}
                                    PSE (Public Sector Entities) HR & Payroll Module Technical Supporting Team Contact Numbers.
                                    <button
                                        type="button" // <-- MUST be "button" so it doesn't submit form
                                        onClick={openPopup}
                                        style={{
                                            marginLeft: "5px",
                                            color: "blue",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            background: "none",
                                            border: "none",
                                            fontSize: "inherit",
                                        }}
                                    >
                                        Click Here
                                    </button>
                                </div> */}
                                {/* <div style={{ textAlign: 'center', padding: '10px 0' }}>
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>Note:</span>{" "}
                                    Pensions
                                    <button
                                        type="button" // <-- MUST be "button" so it doesn't submit form
                                        onClick={openPensionsPopup}
                                        style={{
                                            marginLeft: "5px", color: "blue", textDecoration: "underline",
                                            cursor: "pointer", background: "none", border: "none",
                                            fontSize: "inherit",
                                        }} >
                                        Click Here
                                    </button>
                                </div> */}
                                {showErrorMsg &&
                                    <div className="row">
                                        <div className="col-12  col-sm-12 col-md-12 col-xl-12 col-lg-12">
                                            <div className="  alert alert-danger alert-dismissible fade show" role="alert">
                                                <strong>{localStorage.getItem('loginFailErrorMsg')} </strong>
                                                <button type="button" onClick={() => setShowErrorMsg(false)} className="btn btn-close" data-dismiss="alert"></button>
                                            </div>
                                        </div>
                                    </div>
                                }


                            </form>
                            </div>
                            <div className='alert alert-danger mb-2 login-alert'>
                        <strong>Note:</strong>  A service titled <strong>"USC Number Confirmation"</strong> has been developed in <strong>CFMS</strong> to capture the Unique Service Connection (USC) details used by DDOs. Confirmation of USC details is mandatory for the implementation of the prepaid metering system. All DDOs are requested to complete the USC confirmation to avoid any inconvenience. If you have already completed the USC confirmation, kindly ignore this notification.
                    </div>
                </div>

                <MobileNumbersPopUp showpopup={showpopup} handleClose={handleClose} />
                <PensionsMobileNumbersPopUp showpopup={showPensionspopup} handleClose={handleClosePensions} />
            </FormikProvider>
        </div>
        </>
    );
}
export default LoginPageAuthentication;